import { render, staticRenderFns } from "./MetapropertiesTable.vue?vue&type=template&id=6076e19b"
import script from "./MetapropertiesTable.vue?vue&type=script&lang=js"
export * from "./MetapropertiesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6076e19b')) {
      api.createRecord('6076e19b', component.options)
    } else {
      api.reload('6076e19b', component.options)
    }
    module.hot.accept("./MetapropertiesTable.vue?vue&type=template&id=6076e19b", function () {
      api.rerender('6076e19b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/bynder/MetapropertiesTable.vue"
export default component.exports